import { Price } from './cartDetails/price';
import { AppInjector } from '../utils/services/set-app-injector';
import { CommonInfoService } from '../cart-process/common-info.service';
import { IDevice, IGlobalDevicesMessages, IPrice } from '../interfaces/cart-details.interface';

export class DeviceMessage implements IGlobalDevicesMessages {
  public message: string;
  public isVisible: boolean;
  public messages;
  public uid;

  constructor(messages) {
    this.messages = messages && messages.messages;
    this.uid = messages && messages.uid;
  }
}

export class DeviceModel {
  public image: string;
  public name: string;
  public presale: boolean;
  public price: IPrice;
  public oldPrice?: IPrice;
  public pricePerPiece: IPrice;
  public quantity: number;
  public quantityAligned: boolean;
  public quantityLimitReached: boolean;
  public sku: string;
  public color: string;
  public messages: DeviceMessage;
  public bundledDevice: boolean;

  protected commonInfo: CommonInfoService = AppInjector.get(CommonInfoService);

  constructor(device: IDevice, commonInfo: CommonInfoService) {
    this.image = device.image || '';
    this.name = device.name || '';
    this.presale = device.presale;
    this.price = device.price;
    this.oldPrice = device?.oldPrice;
    this.pricePerPiece = (device.pricePerPiece || new Price())[commonInfo.taxName];
    this.quantity = device.quantity;
    this.quantityAligned = device.quantityAligned;
    this.quantityLimitReached = device.quantityLimitReached;
    this.sku = device.sku;
    this.color = device.color;
    this.messages = new DeviceMessage(device.messages);
    this.bundledDevice = device.bundledDevice || false;
  }

  public getPrice(): string {
    return this.price[this.commonInfo.taxName];
  }

  public getOldPrice(): string | undefined {
    return this.oldPrice ? this.oldPrice[this.commonInfo.taxName] : undefined;
  }
}
